export function normalizeText(value) {
    return String(value ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
}
export function normalizeCompanyName(value) {
    return normalizeText(value)
        .replace(/\b(ltd|limited|inc|llc|plc|gmbh|sarl|sa)\b\.?/g, '')
        .replace(/[.,]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}
export function contactIdentityKey(input) {
    const email = normalizeText(input.email);
    if (email)
        return `email:${email}`;
    return `person:${normalizeText(input.firstName)}|${normalizeText(input.lastName)}|${normalizeCompanyName(input.companyName)}`;
}
export function slug(value) {
    return normalizeText(value)
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'untitled';
}
